<template>
    <li class="dialog-tree-row">
        <div v-show="!loading">
            <div v-if="!editing && $store.claims.dialogs & 1 && $store.claims.phrases & 2"  class="edit-icons">
                <div class="icon-container">
                    <i v-if="!isStart" class='material-icons right grey-text text-darken-1' @click="edit()">edit</i>
                </div>
            </div>
            <div :id="dialog.id" @click="toggle" v-if="!editing" class="text-preview" v-bind:class="{'grey-text text-darken-1': isStart}">
                <span v-if="!isStart" class="number-badge">{{itemNumber}}</span>
                <i class="material-icons " v-bind:class="{'outline': open && !isStart, 'helen-green-text': !isStart}">{{icon}}</i>
                <div class="preview-div">
                {{ primaryTranslation }}
                
                <div v-if="!isStart" dir="auto" class="secondary-language" :id="'secondary-translation-' + dialog.id">{{ secondaryTranslation }}</div>

                </div>
            </div>

            <div v-if="editing" class="editingBox">
                <div class="toolbar">
                    <span v-if="dialog.editor && dialog.created && this.$store.claims.users & 1" class="badge center tooltipped" data-badge-caption=""
                        data-position="top" :data-tooltip="creationInfo">{{editor}}</span>
                    <i @click="edit()" class="material-icons prefix grey-text text-darken-1">undo</i>
                    <i @click="saveTranslationEdit()" class="material-icons prefix grey-text text-darken-1">save</i>
                </div>
                <div class="edit-content-div">
                    <div style="padding-top:2em;padding-right:0.4em">
                        <span class="number-badge">{{itemNumber}}</span>
                        <i class="material-icons prefix helen-green-text">{{icon}}</i>
                    </div>
                    <div class="edit-flexed">
                        <div class="input-field" >
                            <textarea type="text" v-model="editingPhraseText" :style="'height:'+setRows(dialog.id)+'rem'"></textarea>
                        </div>
                        <div dir="auto" class="secondary-language" :id="'secondary-translation-edit-' + dialog.id"> {{ secondaryTranslation }} </div>
                    </div>
                </div>
                <div v-if="dialog.type === 'answer'" class="answer-types">
                    <p>Input type</p>
                    <label v-for="(value, type) in inputTypes" :key="type">
                        <input type="checkbox" :id="type" :value="value" v-model="editingDialog.tags" class="filled-in" disabled="disabled">
                        <span :for="type">{{type}}</span>
                    </label>
                </div>
            </div>

            <ul v-show="open" class="browser-default dialog-tree-list" v-bind:class="{start: isStart}">
                <translateTreeItem v-for="(id, index) in dialog.next" :key="index" :itemNumber="isStart ? (index+1).toString() : itemNumber+'.'+(index+1)" :displaySecondaryLanguage="displaySecondaryLanguage" :secondaryLanguage="secondaryLanguage" :parentOpen="open" :dialog="nextDialogs[id]" v-if="nextDialogs[id]"
                />
            </ul>
            <ul v-show="open" class="browser-default dialog-tree-list" v-bind:class="{start: isStart}">
                <translateTreeItem v-for="(d, key) in nextDialogs" :key="key"  :displaySecondaryLanguage="displaySecondaryLanguage" :secondaryLanguage="secondaryLanguage" :parentOpen="open" :dialog="d" v-if="dialog.next.indexOf(d.id)<0" />
            </ul>
            <ul v-show="open && empty" class="browser-default dialog-tree-list" v-bind:class="{start: isStart}">
                <li class="grey-text text-darken-1 text-preview">Empty</li>
            </ul>
        </div>
        <Spinner v-if="loading" :size="'tiny'" />
    </li>
</template>

<style scoped>
    .start {
        padding-left: 0em
    }

    ul.start > li> div > ul  li {
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        margin-bottom: -1px
    }

    .center {
        position: relative;
        margin-left: -50%;
        left: -50%;
    }
    .secondary-language{
        color: #757575 !important
    }
    .answer-types>label {
        margin-right: 1em
    }

    .answer-types>p {
        color: darkgray
    }

    .icon-spacer {
        width: 24px;
        height: 24px;
        margin-left: 15px
    }

    .dialog-tree-list {
        list-style-type: none;
    }

    .text-preview {
        white-space: nowrap;
        padding-top: 0.4em;
        padding-bottom: 0.4em;
        padding-right: 72px;
    }

    .dialog-tree-row {
        cursor: pointer;
        padding-left: 0;
    }

    .material-icons {
        display: inline-flex;
        vertical-align: top;
        user-select: none;
    }

    .editingBox {
        border: 1px solid lightgray;
        padding: 0em 1em 0em 1em;
        margin-right: -1em
    }

    .edit-icons{
        position: relative;
    }
    .icon-container{
        position: absolute;
        right: 0;
        top: 0.4em;
    }
    .toolbar {
        text-align: right;
        margin: 0em -1em 0em -1em;
        padding: 0.5em 1em 0.5em 1em;
        border-bottom: 1px solid lightgray;
    }

    .toolbar>i {
        margin-left: 0.5em;
    }

    .toolbar>i:hover {
        color: #6EB2BD !important
    }

    .toolbar>.left {
        margin-left: 0
    }

    .toolbar>.left:hover {
        color: #e57373 !important
    }
    .number-badge{
        font-weight: 300;
        color: #fff;
        background-color: grey;
        border-radius: 2px;     padding: 0 6px;
        vertical-align: top
    }
    .preview-div{
        display: inline-block; 
        white-space: normal;
        padding-right: 72px;
    }
    .edit-content-div {
        display: flex;
    }
    .edit-flexed {
        flex-grow: 1;
        padding-bottom: 1em;
    }
</style>
<script>
    import DropDown from "./DropDown";
    import Modal from "./Modal";
    import Spinner from "./Spinner";
    export default {
        name: "translateTreeItem",
        props: {
            dialog: Object,
            parentOpen: Boolean,
            secondaryLanguage: String,
            itemNumber: String,
            displaySecondaryLanguage:Boolean,
        },
        components: {
            DropDown,
            Modal,
            Spinner
        },
        data() {
            return {
                open: false,
                phrase: {},
                nextDialogs: {},
                editing: false,
                editingDialog: null,
                editingPhraseText: '',
                showDeleteModal: false,
                loadingDialogs: true,
                loadingPhrase: true,
                initalized: false,
                inputTypes: {
                    "Multi-select": "multiselect",
                    "Number": "input_number",
                },
                dropdownActions: {
                    Category: () => {
                        this.addDialog('category')
                    },
                    Question: () => {
                        this.addDialog('question')
                    },
                    Instruction: () => {
                        this.addDialog('instruction')
                    },
                    Answer: () => {
                        this.addDialog('answer')
                    }
                },
                deleteModalActions: {
                    Yes: () => {
                        this.removeDialog(this.dialog)
                        this.showDeleteModal = false
                    },
                    No: () => {
                        this.showDeleteModal = false
                    },
                }
            }
        },
        watch: {
            parentOpen: function (isOpen) {
                if (!isOpen) {
                    this.open = false
                } else if (!this.initialized) {
                    this.getNext().then(() => this.loadingDialogs = false).catch(() => this.loadingDialogs = false)
                    this.initialized = true
                }
            },
            'dialog.phrase': function (id) {
                this.getPhraseByID(id)
            },
            'dialog.next': function (list) {
                this.nextDialogs = Object.keys(this.nextDialogs).filter((d) => {
                    return this.dialog.next.indexOf(this.nextDialogs[d].id) > -1 || this.nextDialogs[d].new;
                }).reduce((obj, key) => {
                    obj[key] = this.nextDialogs[key];
                    return obj;
                }, {});
                var newDialogs = []
                this.dialog.next.forEach(id => {
                    if (!this.nextDialogs[id]) {
                        newDialogs.push(id)
                    }
                });
                newDialogs.forEach(element => {
                    this.getDialogByID(element)
                });
            }
        },
        methods: {
            setRows(id){
                var target = document.getElementById("secondary-translation-" + id) ? document.getElementById("secondary-translation-" + id) : document.getElementById("secondary-translation-edit-" + id) ;
                if(!target) return 4;
                var style = window.getComputedStyle(target, null);
                var height = parseInt(style.getPropertyValue("height"));
                var font_size = parseInt(style.getPropertyValue("font-size"));
                var line_height = parseInt(style.getPropertyValue("line-height"));
                var box_sizing = style.getPropertyValue("box-sizing");
  
                if(isNaN(line_height)) line_height = font_size * 1.2;
 
                if(box_sizing=='border-box')
                {
                    var padding_top = parseInt(style.getPropertyValue("padding-top"));
                    var padding_bottom = parseInt(style.getPropertyValue("padding-bottom"));
                    var border_top = parseInt(style.getPropertyValue("border-top-width"));
                    var border_bottom = parseInt(style.getPropertyValue("border-bottom-width"));
                    height = height - padding_top - padding_bottom - border_top - border_bottom
                }
                var lines = Math.ceil(height / line_height);
                return lines < 5 ? 4*lines : 2*lines;
            },
            /**
             * Toggle folder state
             */
            toggle() {
                this.open = !this.open || this.isStart
            },
            /**
             * Fetch dialog based on ID
             * @param {string} id ID of dialog to fetch
             */
            getDialogByID(id) {
                return new Promise((resolve, reject) => {
                    this.$http.get("/dialogs/" + id).then(
                        response => {
                            if (!response.data.next)
                                response.data.next = []
                            this.$set(this.nextDialogs, id, response.data)
                            resolve()
                        },
                        response => {
                            reject()
                        }
                    );
                })
            },
            /**
             * Fetch phrase based on ID
             * @param {number} id ID of pharse to fetch
             */
            getPhraseByID(id) {
                return new Promise((resolve, reject) => {
                    if (!id) {
                        resolve()
                        return
                    }
                    const storedPhrase = this.$store.phrases.filter(p => p.id === id)[0]
                    if (storedPhrase) {
                        this.phrase = storedPhrase
                        resolve()
                    } else
                        this.$http.get("/phrases/" + id).then(
                            response => {
                                this.phrase = response.data;
                                resolve()
                            },
                            response => {
                                reject()
                            }
                        );

                })
            },
            /**
             * Append a new dialog with the this dialog as parent
             * @param {string} type The type of the new dialog
             */
            addDialog(type) {
                this.open = true
                const tempID = Math.random().toString(36).substr(2, 9)
                this.$set(this.nextDialogs, tempID, {
                    id: tempID,
                    new: true,
                    editor: this.$store.userID,
                    creator: this.$store.userID,
                    phrase: null,
                    next: [],
                    tags: [],
                    type: type
                })
            },
            /**
             * Toggle editing state
             */
            edit() {
                this.editing = !this.editing
                if (this.editing) {
                    this.editingDialog = Object.assign({}, this.dialog)
                    this.editingPhraseText = this.primaryEditingTranslation
                    this.editingDialog.tags = this.editingDialog.tags == undefined ? [] : this.editingDialog.tags
                    this.editingDialog.editor = this.$store.userID
                }
            },
            /**
             * Call for saving changes to current phrase
             */
            saveTranslationEdit() {
                if (this.editingPhraseText.length < 1) {
                    this.toast('You can\'t save an empty translation')
                    return
                }
                var keys = Object.keys(this.phrase)
                var translation = {
                            text: "",
                            language: this.$store.preferredLanguage,
                        }
                translation.text = this.editingPhraseText
                this.$store.putTranslation(this.phrase.id,translation).then( p =>
                    this.phrase = p
                ).catch(() => this.toast('Could not update translation'))
                this.editing = false
            },
            /**
             * Prepare a phrase for posting and if success add it to the store
             * @param {string} translationText Text of translation
             * @param {string} translationLanguage Language of translation
             */
            createNewPhrase(translationText, translationLanguage) {
                return new Promise((resolve, reject) => {
                    var phrase = {
                        translations: [{
                            text: translationText,
                            language: translationLanguage,
                        }]
                    }
                    this.$store.postPhrase(phrase).then(id => {
                        phrase.id = id
                        resolve(id)
                    }).catch(() => reject(Error("Could not add phrase")))
                })
            },
            /**
             * Retireves the next dialogs
             */
            getNext() {
                return new Promise((resolve, reject) => {
                    var a = this.dialog.next.map(id => {
                        return this.getDialogByID(id)
                    });
                    Promise.all(a).then(() => resolve());
                })
            },
            toast(text) {
                M.toast({
                    html: text
                })
            }
        },
        /**
         * Intitialize the component
         */
        created() {
            if (this.isStart)
                this.open = true
            if (this.dialog.new)
                this.edit()
            this.getPhraseByID(this.dialog.phrase).then(() => this.loadingPhrase = false).catch(() => this.loadingPhrase =
                false)
            if (this.parentOpen) {
                this.getNext().then(() => {
                    this.loadingDialogs = false;
                    this.initialized = true;
                }).catch(() => {
                    this.loadingDialogs = false;
                    this.toast('Could not fetch the next set of dialogs')
                })
            }
        },
        /**
         * Handle Materialize components on graphical update
         */
        updated() {
            var tooltips = document.querySelectorAll('.tooltipped');
            if (tooltips)
                M.Tooltip.init(tooltips, {})
        },
        computed: {
               /**
             * Get translation based on current preferred language
             */
            secondaryTranslation() {
                if (this.isStart)
                    return ''
                    
                if (this.secondaryLanguage === "")
                    return 'No secondary language is selected'
                    
                if (this.phrase.translations)
                    var foundTranslation = this.phrase.translations.filter(t => t.language === this.secondaryLanguage)[
                        0]
                if (foundTranslation)
                    return foundTranslation.text
                return foundTranslation ? foundTranslation.text : 'Phrase has no translation for the secondary language'
            },
            /**
             * Get translation based on current preferred language
             */
            primaryTranslation() {
                if (this.isStart)
                    return 'Root'
                if (this.phrase.translations)
                    var foundTranslation = this.phrase.translations.filter(t => t.language === this.$store.preferredLanguage)[
                        0]
                if (foundTranslation)
                    return foundTranslation.text
                return foundTranslation ? foundTranslation.text : 'Phrase has no translation for this language'
            },
          
            /**
             * Get translation based on current preferred language (if none found => '')
             */
            primaryEditingTranslation() {
                if (this.phrase.translations)
                    var foundTranslation = this.phrase.translations.filter(t => t.language === this.$store.preferredLanguage)[
                        0];
                return foundTranslation ? foundTranslation.text : ''
            },
            /**
             * Get icon based on dialog's type
             */
            icon() {
                const types = {
                    'answer': 'chat',
                    'instruction': 'feedback',
                    'question': 'help',
                    'category': 'folder',
                    'start': 'view_list',
                    'default': 'error'
                }
                return (types[this.dialog.type] || types[this.isStart ? 'start' : 'default'])
            },
            /**
             * Returns last editor of dialog
             */
            editor() {
                const modifier = this.$store.users.filter(u => u.id === this.dialog.editor)[0]
                return modifier ? modifier.username : ''
            },
            creationInfo() {
                const creator = this.$store.users.filter(u => u.id === this.dialog.creator)[0]
                return creator && this.dialog.created ? "Created by " + creator.username + " ( " + this.dialog.created.split(
                    'T')[0] + " " + this.dialog.created.split('T')[1].slice(0, 5) + " )" : ''
            },
            /**
             * Get empty state of nextDialogs
             */
            empty() {
                for (var key in this.nextDialogs) {
                    if (this.nextDialogs.hasOwnProperty(key))
                        return false;
                }
                return true;
            },
            /**
             * Returns if dialog is start-dialog
             */
            isStart() {
                return this.dialog.tags && this.dialog.tags.indexOf('start') > -1
            },
            /**
             * Returns if the dialog is loading
             */
            loading() {
                return this.loadingPhrase || this.loadingDialogs
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/TranslateTreeItem.vue